__turbopack_context__.v({
  "checkboxInput": "CheckboxInput-module__4RDN-G__checkboxInput",
  "checked": "CheckboxInput-module__4RDN-G__checked",
  "icon": "CheckboxInput-module__4RDN-G__icon",
  "label": "CheckboxInput-module__4RDN-G__label",
});
